import { cn } from '@heroui/react';
import { ReactNode } from 'react';

export type ContentHeaderControlGroupProps = {
  className?: string;
  children?: ReactNode;
};

export function ContentHeaderControlGroup(
  props: ContentHeaderControlGroupProps
) {
  const { className, children } = props;

  return (
    <div className={cn('flex items-end gap-2.5', className)}>{children}</div>
  );
}
